<ng-container>
  <div class="d-flex flex-row justify-content-between px-3 py-2">
    <span class="text-muted">
      <span
        class="text-uppercase"
        i18n="
          Accounts|Selected Accounts selection
          header@@selectedAccountsSectionHeader"
        >Selected account{selectedAccounts.length, plural, =1{} other{s}}</span
      >
      @if (selectedAccounts.length > 1) {
      <span class="ml-1">&#40;{{ selectedAccounts.length }}&#41;</span>
      }
    </span>

    @if (selectedAccounts.length > 2 || isOpen) {
    <span (click)="toggleOpen()" class="d-flex cursor-pointer">
      @if (isOpen) {
      <span i18n="Accounts|Selected Accounts see less@@selectedAccountsSeeLess"
        >See less</span
      >
      } @else {
      <span i18n="Accounts|Selected Accounts see all@@selectedAccountsSeeAll"
        >See all</span
      >
      }
      <fa-icon
        [icon]="isOpen ? ['fas', 'angle-down'] : ['fas', 'angle-up']"
        class="mr-2 ml-1 align-items-end"
      >
      </fa-icon>
    </span>
    }
  </div>
  <div class="overflow-auto">
    @for ( account of selectedAccounts | slice: 0:(isOpen ? undefined : 2) ;
    track account) {
    <div class="custom-checkbox">
      <input
        class="custom-control-input"
        type="checkbox"
        [attr.data-e2e]="
          'selected-account-selected-checkbox-' + account.externalId
        "
        (click)="deselectAccount($event, account)"
        [id]="account.accountId"
        checked="true"
      />
      <label
        class="custom-control-label account-label pb-1 cursor-pointer w-100"
        [for]="account.accountId"
      >
        <epc-account-details [account]="account"></epc-account-details>
        <br />
        <span class="text-muted" data-e2e="selected-address-detail">
          {{ getFullShipToAddress(account.shipToAddresses[0]) }}
        </span>
      </label>
    </div>
    }
  </div>
</ng-container>
